import React from 'react'
import type { ComponentProps, PartData } from '@enonic/react-components'
import ListPeoplePrototype from '/react4xp/components/prototype/ListPeople'
import type { ListPeopleProps, PersonCard } from '/react4xp/components/prototype/ListPeople/types'
import { EditorPlaceholder } from '/react4xp/components/shared/EditorPlaceholder'

type ProcessorPersonCard = {
	photo?: { src: string; alt?: string }
	name?: string
	jobTitle?: string
	location?: string
	email?: string
	phone?: string
}

type ListPeoplePartData = {
	overline?: string
	title?: string
	people?: ProcessorPersonCard[]
	prevLabel?: string
	nextLabel?: string
}

export const ListPeople = ({ meta, data }: ComponentProps<PartData>) => {
	const { overline, title, people = [], prevLabel, nextLabel } = (data || {}) as ListPeoplePartData
	const personCards: PersonCard[] = people.map((person) => ({
		photo: person.photo && { src: person.photo.src, alt: person.photo.alt || person.name || '' },
		name: person.name || '',
		jobTitle: person.jobTitle,
		location: person.location,
		email: person.email,
		phone: person.phone,
	}))

	// An unconfigured part still has to render something in Content Studio, or the
	// editor cannot select it to fill it in.
	if (!overline && !title && personCards.length === 0) {
		return (
			<EditorPlaceholder
				mode={meta?.mode}
				componentClass="list-people"
				title="List people"
				reason="No employees selected."
			/>
		)
	}

	const props: ListPeopleProps = {
		overline,
		title,
		people: personCards,
		prevLabel,
		nextLabel,
	}

	return <ListPeoplePrototype {...props} />
}
